<template>
    <div class="container">
        <div class="row">
            <title-area title="Viktimat e Krimit"/>
        </div>
        <div class="row">
            <p>
                Viktimë e krimit është çdo person që ka pësuar dëm duke përfshirë dëmin fizik, mendor, emocional ose
                edhe humbjen ekonomike të shkaktuar nga një vepër penale të dhunshme
                Viktimat e krimit janë: viktimat e dhunës në familje dhe formave tjera të dhunës në baza gjinore,
                viktimat e trafikimit me njerëz, viktimat e dhunimit, ngacmimeve dhe abuzimeve seksuale, viktimat e
                grabitjes dhe sulmeve të dhunshme. Viktimë janë edhe anëtarët e familjes së viktimave të vrasjeve,
                vdekja e të cilëve është shkaktuar drejtpërdrejt nga vepra penale.
                Viktimave të krimit ju njihen një mori të drejtash në kuadër të ligjeve të Republikës së Kosovës dhe u
                ofrohet mbrojtje, siguri, rehabilitim dhe ri integrim.
            </p>

            <h5 class="mb-4 fw-bold">Si viktimë e krimit, ju keni të drejtën:</h5>

            <!-- Pjesa e parë me d-flex -->
            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të trajtoheni me respekt, ndjeshmëri dhe dinjitet dhe në mënyrë profesionale dhe jo diskriminuese
                    nga policia, prokurorët, mbrojtësit e viktimave, gjyqtarët dhe organet tjera me të cilët keni
                    kontakt.
                </p>
            </div>

            <!-- Pjesa tjetër, secila me d-flex për të ruajtur të njëjtin format -->
            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të informoheni rreth të drejtave të juaja, pa vonesa që nga kontakti i juaj i parë me policinë,
                    mbrojtësit e viktimave, prokurorët, gjyqtarët dhe organet tjera.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të njoftoheni lidhur me rastin tuaj dhe procedurat në polici, prokurori dhe gjykatë.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të keni qasjen në ndihmë mjekësore, mbështetjen psikologjike, strehim alternativ, përfaqësim ligjor
                    dhe ndihmën juridike falas përfshirë këtu edhe përfaqësimin nga Zyra për Mbrojtje dhe Ndihmë
                    Viktimave.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të kërkoni mbrojtje duke përfshirë edhe masat mbrojtëse të parapara me ligj.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të dëgjoheni nga policia, mbrojtësi i viktimave, prokuroria dhe gjykata.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të keni qasje në përkthim pa pagesë nëse nuk e kuptoni gjuhën në të cilën zhvillohet procedura.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Të keni të drejtë për kompensim nga i dëmtuari në procedurën penale ose të kërkoni kompensim nga
                    Programi për Kompensimin e Viktimave të Krimit.
                </p>
            </div>
        </div>
        <div class="row">
            <h5 class="mb-4 fw-bold">Si viktimë e krimit, ju keni të drejtën:</h5>

            <!-- Pjesa e parë me d-flex -->
            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Strehim: viktimat e dhunës në familje dhe viktimat e trafikimit dhe viktimat fëmijë vendosen në
                    strehimoret e specializuara të Kosovës. Viktimat që kanë nevojë për strehim pas veprës penale,
                    policia ka për obligim t’i shoqërojë në strehimoren më të afërt ku iu ofrohet strehim i sigurt,
                    veshëmbathje, kujdes shëndetësor dhe shërbime tjera gjatë kohës së qëndrimit në strehimore.
                </p>
            </div>

            <!-- Pjesa tjetër, secila me d-flex për të ruajtur të njëjtin format -->
            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Kujdes mjekësor: policia dhe punëtorët social i referojnë viktimat në institucionet shëndetësore për
                    ndihmën emergjente mjekësore. Institucionet publike shëndetësore ofrojnë shërbim mjekësor falas për
                    viktimat e krimit.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Shërbimet e këshillimit: në disa raste viktimave iu ofrohet këshillimi psikologjik nga stafi i
                    specializuar i strehimores dhe në disa raste tjera ato edhe referohen në institucionet shëndetësore
                    që ofrojnë këshillim psikologjik. Viktimat kanë nevojë për këshillim psikologjik duke pasur parasysh
                    përvojën traumatike si rezultat i dhunës që e kanë përjetuar.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Mbështetja ligjore: viktimave të krimit u ofrohet ndihmë dhe përfaqësim ligjor pa pagesë nga
                    Mbrojtësit e Viktimave që nga momenti i identifikimit, para, gjatë dhe pas procedurës gjyqësore.
                    Mbrojtësit e viktimave i ndihmojnë viktimat të parashtrojnë kërkesën për urdhër mbrojtje nga
                    gjykata, përfaqësojnë viktimën në prokurori e gjykatë, si dhe i ndihmojnë viktimat të plotësojnë
                    kërkesën për kompensim nga shteti.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Arsimimi dhe punësimi: punëtorët social hartojnë planin individual për menaxhimin e rastit të
                    viktimave dhe bëjnë referimin e viktimës në institucionet edukative, në disa raste ndihmojnë kthimin
                    e viktimave në arsim, angazhimin në kurse të ndryshme profesionale dhe referimin për qendrat
                    rajonale për punësim.
                </p>
            </div>

            <div class="d-flex">
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1 pt-1" />
                <p class="list-item">
                    Kompensimi i viktimave: mbrojtësit e viktimave asistojnë viktimat që gjatë procedurës penale të
                    plotësojnë deklaratën e dëmit për të kërkuar dëmshpërblimin nga i pandehuri. Në rastet kur viktimat
                    nuk mund të realizojnë dëmshpërblimin nga kryesi, atëherë kanë mundësinë e kompensimit nga shteti.
                    Secili institucion ka për obligim të njoftojë viktimën për të drejtën e tyre në kompensim,
                    Mbrojtësit e viktimave ndihmojnë viktimën që të plotësojë dhe dorëzojë kërkesën për kompensim në
                    Programin e Kompensimit të Viktimave të Krimit.
                </p>
            </div>
        </div>

        <div class="row">
            <h5 class="mb-4 fw-bold">PROGRAMI I KOMPENSIMIT TË VIKTIMAVE TË KRIMIT</h5>

            <!-- Pjesa e parë me d-flex -->
            <div class="d-flex">
                <p class="list-item">
                    Programi për kompensimin e viktimave të krimit financohet nga Buxheti i Republikës së Kosovës. Programi ia mundëson viktimave të veprave të dhunshme të kompensueshme të aplikojnë për kompensim financiar për dëmet si pasojë e veprës penale. Kompensimi nga shteti mund të kërkohet në rastet kur viktima nuk mund ta realizojë të drejtën për dëmshpërblim nga i pandehuri apo kompensim nga burimet tjera.  
                </p>
            </div>
            <div class="d-flex">
                <p class="list-item">
                    Informatat e detajuara lidhur me kompensimin e viktimave mund t’i gjeni në broshurat dhe formularët e bashkëngjitura më poshtë. Shihni broshurën informuese dhe formularët për parashtrimin e kërkesës për kompensim.
                </p>
            </div>
        </div>
        <div class="row d-flex justify-content-end">
            <button class="btn btn-primary" href="/src/">
                Shkarko Broshurën <font-awesome-icon icon="fa-solid fa-download" />
            </button>
        </div>
    </div>
</template>
<script>
import TitleArea from '../share/TitleArea.vue'
export default {
    components: { TitleArea },
}
</script>
<style scoped>
button{
    background-color:#2C3F5E;
    padding:10px 16px;
    border-radius:8px;
    width:220px;
}
</style>